import React, { Fragment } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { MainContainer, MainTitle, TitleContainer, Paragraph, ColumnContainer, Column, MainButton, ButtonsRow, SectionTitle, HeadSeo, LoadingContainer, Breadcrumbs, Divider } from '@beacharound/beacharound-ui';

import { getDistrict } from '../../api/places';
import { getGeoBreadCrumbs, getGeoBreadCrumbsHotel } from '../../helpers/getGeoBreadCrumbs';

import HotelsSlider from '../../components/Hotels/HotelsSlider';
import BeachesSlider from '../../components/Beaches/BeachesSlider';
import CitiesHighlight from '../../components/General/Home/CitiesHighlight';

export default function PlaceDetail({ match }) {

    const isHotel = match.url.includes('i-migliori-hotel')
    const { districtSlug } = match.params;

    const { data: district, isLoading } = useQuery(["district", districtSlug], () =>
        getDistrict({ slug: districtSlug })
    );

    return (
        <LoadingContainer isLoading={isLoading}>
            {district && (
                <Fragment>
                    <HeadSeo
                        title={[(isHotel ? `Prenota camere e offerte hotel a ${district.name}` : `Prenota il tuo ombrellone in spiaggia a ${district.name}`)]}
                        name={district.name}
                        type="City"
                    />

                    <MainContainer>
                        <TitleContainer>
                            <Breadcrumbs
                                breadcrumbs={isHotel ? getGeoBreadCrumbsHotel(district?.geoElements) : getGeoBreadCrumbs(district?.geoElements, {
                                    others: [{
                                        label: district.name,
                                        url: match.url
                                    }]
                                })}
                                linkComponent={Link}
                            />
                            <MainTitle
                                text={isHotel ? `Prenota camere e offerte hotel a <strong>${district.name}</strong>` : `Prenota il tuo ombrellone in spiaggia a <strong>${district.name}</strong>`}
                                component="h1"
                            />
                        </TitleContainer>

                        <CitiesHighlight match={match} districtSlug={districtSlug} />

                        <Divider />

                        {isHotel ?
                            <HotelsSlider
                                title={`I migliori hotel a ${district.name}`}
                                subtitle={`Richiedi preventivi e prenota senza commissione in Hotel selezionati per te. Scopri le offerte e le promozioni e risparmia senza fare compromessi!`}
                                params={{ "address.district": district.iso }}
                            />
                            :
                            <BeachesSlider
                                title={`Le migliori spiagge a ${district.name}`}
                                subtitle={`Scopri le spiagge più belle a ${district.name} e prenota il tuo ombrellone!`}
                                params={{ "address.district": district.iso }}
                            />
                        }

                        {isHotel ?
                            <BeachesSlider
                                title={`Le migliori spiagge a ${district.name}`}
                                subtitle={`Scopri le spiagge più belle a ${district.name} e prenota il tuo ombrellone!`}
                                params={{ "address.district": district.iso }}
                            />
                            :
                            <HotelsSlider
                                title={`I migliori hotel a ${district.name}`}
                                subtitle={`Richiedi preventivi e prenota senza commissione in Hotel selezionati per te. Scopri le offerte e le promozioni e risparmia senza fare compromessi!`}
                                params={{ "address.district": district.iso }}
                            />
                        }
                    </MainContainer>

                    <MainContainer>
                        <TitleContainer>
                            <SectionTitle text="Sei il gestore di una spiaggia, un hotel o offri esperienze?" />
                            <Paragraph text="Beacharound è sempre alla ricerca di nuovi partner. Inserisci la tua attività!" />
                        </TitleContainer>
                        <ColumnContainer>
                            <Column>
                                <ButtonsRow>
                                    <MainButton
                                        border
                                        text="Inserisci la tua attività"
                                        component="a"
                                        to={process.env.REACT_APP_BUSINESS_URL}
                                        blank
                                    />
                                </ButtonsRow>
                            </Column>
                        </ColumnContainer>

                        <TitleContainer>
                            <MainTitle text="Sei il rappresentate di un comune o di un ente pubblico?" />
                            <Paragraph text="Beacharound mette a disposizione alle pubbliche amministrazioni gli strumenti necessari per promuovere e gestire le spiagge libere!" />
                        </TitleContainer>
                        <ButtonsRow>
                            <MainButton
                                border
                                text="Collabora con noi"
                                component="a"
                                to={process.env.REACT_APP_BUSINESS_URL}
                                blank
                            />
                        </ButtonsRow>

                    </MainContainer>
                </Fragment>
            )}
        </LoadingContainer>
    );
}